import React from 'react';
import * as Opt from '../editor/Helpers'
import { CalculateSpacing } from '../editor/Helpers';
import ColorSelector from '../editor/fields/ColorSelector';

class PostCommon extends React.Component {
    constructor() {
        super();
    }

    render() {
        let breadcrumb = Window.react_data.breadcrumbs ? Window.react_data.breadcrumbs : [{slug: "/link/", name: "Category1"}, {slug: "/link/", name: "Category2"}]
        let title = Window.react_data.title ? Window.react_data.title : "Page Title"

        let published_date = Window.react_data.published_date ? Window.react_data.published_date : "2024-03-04"
        let dateobject = new Date(Date.parse(published_date))
        let formatted_date = dateobject.getDate().toString() + " " + dateobject.toLocaleString('default', { month: 'short' }) + " " + dateobject.getUTCFullYear().toString();

        return <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : 'flex'} bg-${this.props.backgroundColor}`}>
            <div className={`container ${CalculateSpacing(this.props.spacing)} overflow-hidden`}>
                <div className="flex flex-wrap">
                    <div className="w-full">
                        <p className="fs-5 flex items-center mb-[60px] mt-[60px] flex-wrap">
                        {breadcrumb.map((itm) => {
                            return <>
                            <a style={{lineHeight:"28px"}} href={itm.slug}>{itm.name}</a>
                            <img className="mx-2" src={`${Window.static_path}img/icons/caret.svg`} style={{height:"28px", width:"28px"}} />
                            </>;
                        })}
                        <a style={{lineHeight:"28px"}} href="">{title}</a>
                        </p>

                        <h1 className="n-h3 font-bold mb-[60px]">{title}</h1>
                        <p className="fs-5 mb-[20px]">{formatted_date}</p>
                    </div>
                </div>
            </div>
        </div>;
    }
}

PostCommon.defaultProps = {
    visibility: "",
    backgroundColor: 'white-50',
    spacing: [],
}

PostCommon.fields={
    visibility: {
        type: "select",
        options: Opt.visibilityOptions
      },
    backgroundColor: {
        type: "custom",
        render: (props) => <ColorSelector {...props} />
    },
    spacing: Opt.spacingOptions,
}

export default PostCommon;
